<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  created(){
    var userFromLocalstorage = localStorage.getItem('garb2buser');
    if(userFromLocalstorage==null) this.$router.replace("/login/");

    console.log(process.env.VUE_APP_API_URL);

  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
